import { render, staticRenderFns } from "./TenantSettingsSetup.vue?vue&type=template&id=d0031e50&scoped=true&"
import script from "./TenantSettingsSetup.vue?vue&type=script&lang=ts&"
export * from "./TenantSettingsSetup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0031e50",
  null
  
)

export default component.exports